import React from "react";
import { connect } from "react-redux";
import { getLoanNotes, addNoteToLoan, deleteNote } from "store/state/loan/loan";
import NotesDrawer from "components/Global/Notes/NotesDrawer";
import _ from "lodash";

class LoanNotes extends React.Component {
  componentDidUpdate(prevProps, prevState) {
    const { loanId, isOpen } = this.props;
    const { isOpen: prevIsOpen } = prevProps;

    if (isOpen !== prevIsOpen && isOpen) {
      this.props.getLoanNotes({
        modelName: "loan",
        modelId: loanId,
        subKey: loanId
      });
    }
  }

  handleRemove = noteId => {
    const { loanId } = this.props;

    this.props.deleteNote({
      noteId: noteId,
      shouldUpdateAfter: true,
      modelName: "loan",
      modelId: loanId,
      subKey: loanId
    });
  };

  render() {
    const { isOpen, closeNotes, loanNotes, loanId, addNoteToLoan } = this.props;
    const specificLoanNotes = loanNotes[loanId] || [];

    return (
      <React.Fragment>
        <NotesDrawer
          drawerWidth={600}
          addNote={note => addNoteToLoan("loan", loanId, note)}
          isOpen={isOpen}
          closeDrawer={closeNotes}
          notes={specificLoanNotes}
          handleRemove={this.handleRemove}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ loan }) => ({
  loanNotes: loan.loanNotes
});

export default connect(
  mapStateToProps,
  {
    getLoanNotes,
    addNoteToLoan,
    deleteNote
  }
)(LoanNotes);
